import axios from 'axios';
import BaseCrud from './baseCrud';

const crud = new BaseCrud('loan');

export const state = () => ({
    ...crud.state,
    PENDING: 'pending',
    ACTIVE: 'active',
    REJECTED: 'rejected',
    CANCELLED: 'cancelled',
    ENDED: 'ended'
});

export const getters = {
    ...crud.getters,

    PENDING: state => state.PENDING,
    ACTIVE: state => state.ACTIVE,
    REJECTED: state => state.REJECTED,
    CANCELLED: state => state.CANCELLED,
    ENDED: state => state.ENDED,
    ALL_STATUSES: state => [
        {
            text: 'Pending',
            value: state.PENDING
        },
        {
            text: 'Active',
            value: state.ACTIVE
        },
        {
            text: 'Ended',
            value: state.ENDED
        },
        {
            text: 'Rejected',
            value: state.REJECTED
        },
        {
            text: 'Cancelled',
            value: state.CANCELLED
        }
    ]
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index(
        vuexContext,
        {
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters,
            loanProductId = null,
            status = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC',
            filters: JSON.stringify(filters)
        };

        if (loanProductId) {
            params.loanProductId = loanProductId;
        }

        if (status) {
            params.status = status;
        }

        return axios.$get('/admin/loans', {
            params
        });
    },

    updateStatus(vuexContext, { id, status }) {
        return axios.$post(`/admin/loans/${id}/status`, { status });
    }
};
